var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "archive",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.131,
    height: 21.561,
    viewBox: "0 0 23.131 21.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M24.3,2.9H2.826A.78.78,0,0,0,2,3.726V8.435a.78.78,0,0,0,.826.826H3.57V23.635a.78.78,0,0,0,.826.826H22.735a.78.78,0,0,0,.826-.826V9.261H24.3a.78.78,0,0,0,.826-.826V3.726A.828.828,0,0,0,24.3,2.9Zm-2.4,19.992H5.222V9.261H21.909Zm1.57-15.283H3.652V4.552H23.479Z",
    transform: "translate(-2 -2.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M11.826,16.652h6.609a.826.826,0,0,0,0-1.652H11.826a.826.826,0,0,0,0,1.652Z",
    transform: "translate(-3.565 -5.004)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.e680d27b77cfd0cc6abaad9d9b3136bb.svg";
export { ForwardRef as ReactComponent };